/**
 * @desc 更新车牌信息信息
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/importLicensePlate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
